import { RouteObject } from "react-router-dom";

import { PrivateRoute } from "../auth/auth";

import MainPage from "../components/main-page";
import Home from "../layout/home";

export const routesConfig = () => {
  const RoutesConfig: RouteObject[] = [
    {
      element: (
        <PrivateRoute>
          <Home />
        </PrivateRoute>
      ),
      path: "*",
      children: [],
      id: "default",
    },
    {
      element: (
        <PrivateRoute>
          <Home />
        </PrivateRoute>
      ),
      path: "/",
      children: [],
      id: "home",
    },
    {
      element: (
        <PrivateRoute>
          <MainPage />
        </PrivateRoute>
      ),
      path: "/ws/:id",
      children: [],
      id: "main",
    },
  ];

  return RoutesConfig;
};
